import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

export const fetctUSPDesign = async (designNumber) => {
  const response = await apiClient.get(`${config.baseUrl}/api/v1/styles/getUSPDesign/${designNumber}`);
  return response.data.data;
};

export const useUSPDesignQuery = (designNumber) => {
  return useQuery({
    queryKey: ["use-design", designNumber],
    queryFn: () => fetctUSPDesign(designNumber),
    enabled: !!designNumber,
    staleTime: 100 * 60 * 5,
  });
};
